var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18.3333C0 19.2538 0.746192 20 1.66667 20H28.3333C29.2538 20 30 19.2538 30 18.3333C30 17.4129 29.2538 16.6667 28.3333 16.6667H1.66667C0.746193 16.6667 0 17.4129 0 18.3333ZM0 10C0 10.9205 0.746192 11.6667 1.66667 11.6667H28.3333C29.2538 11.6667 30 10.9205 30 10C30 9.07952 29.2538 8.33333 28.3333 8.33333H1.66667C0.746193 8.33333 0 9.07952 0 10ZM1.66667 0C0.746193 0 0 0.746192 0 1.66667C0 2.58714 0.746192 3.33333 1.66667 3.33333H28.3333C29.2538 3.33333 30 2.58714 30 1.66667C30 0.746192 29.2538 0 28.3333 0H1.66667Z",
    fill: "#111111"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 10L10 30",
    stroke: "#212121",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L30 30",
    stroke: "#212121",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "male-icon",
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.773 0a2 2 0 0 0-2 2v3.519a2 2 0 0 0 2 2h6.258L30.147 18.263a19.539 19.539 0 0 0-10.603-3.104C8.75 15.159 0 23.853 0 34.579 0 45.304 8.75 54 19.544 54c10.793 0 19.541-8.696 19.541-19.421 0-4.077-1.263-7.86-3.423-10.984L46.363 12.96v6.134a2 2 0 0 0 2 2h3.566c1.105 0 2-.895 2.002-2 .01-5.473.058-11.633.067-17.095C54 .895 53.105 0 52 0H34.773Zm-15.23 22.976c6.45 0 11.676 5.194 11.676 11.603 0 6.408-5.227 11.604-11.675 11.604-6.45 0-11.678-5.196-11.678-11.604 0-6.409 5.229-11.603 11.678-11.603Z",
    fill: "#23C2EF"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -1,
    y: -3,
    width: 54.998,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_200_964"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_200_964",
    result: "effect2_innerShadow_200_964"
  }))))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "female-icon",
    viewBox: "0 0 40 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C9.357 0 .727 8.63.727 19.273c0 8.813 5.919 16.246 13.997 18.542.922.262 1.606 1.075 1.606 2.033v2.553a2 2 0 0 1-2 2h-4.266a2 2 0 0 0-2 2v3.337a2 2 0 0 0 2 2h4.266a2 2 0 0 1 2 2V58a2 2 0 0 0 2 2h3.337a2 2 0 0 0 2-2v-4.262a2 2 0 0 1 2-2h4.265a2 2 0 0 0 2-2v-3.337a2 2 0 0 0-2-2h-4.265a2 2 0 0 1-2-2v-4.204c8.889-1.713 15.606-9.535 15.606-18.924C39.273 8.63 30.643 0 20 0Zm0 7.664c6.412 0 11.61 5.197 11.61 11.61 0 6.41-5.198 11.608-11.61 11.608-6.412 0-11.61-5.197-11.61-11.609S13.589 7.663 20 7.663Z",
    fill: "#FF8787"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "button-load-pets-image",
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 49.166V25.5m0 0V1.833m0 23.667h23.667m-23.667 0H1.833",
    stroke: "#111",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "male-icon-mobile",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.849 0a2 2 0 0 0-2 2v1.012a2 2 0 0 0 2 2h3.505l-7.256 7.163a13.026 13.026 0 0 0-7.069-2.069C5.834 10.106 0 15.902 0 23.052 0 30.202 5.834 36 13.029 36s13.028-5.797 13.028-12.948c0-2.718-.842-5.24-2.282-7.322l7.134-7.09v3.422a2 2 0 0 0 2 2h1.044c1.104 0 2-.895 2.003-2 .008-3.252.033-6.815.041-10.063C36 .895 35.105 0 34 0H23.85Zm-10.82 15.317c4.3 0 7.784 3.463 7.784 7.735 0 4.273-3.485 7.737-7.784 7.737-4.3 0-7.785-3.464-7.785-7.737 0-4.272 3.486-7.735 7.785-7.735Z",
    fill: "#23C2EF"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -1,
    y: -3,
    width: 36.997,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_2418_892"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_2418_892",
    result: "effect2_innerShadow_2418_892"
  }))))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "female-icon-mobile",
    viewBox: "0 0 26 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.905 0 .151 5.753.151 12.849c0 5.682 3.691 10.504 8.806 12.199.91.302 1.596 1.11 1.596 2.068v.485a2 2 0 0 1-2 2h-1.51a2 2 0 0 0-2 2v.891a2 2 0 0 0 2 2h1.51a2 2 0 0 1 2 2V38a2 2 0 0 0 2 2h.891a2 2 0 0 0 2-2v-1.508a2 2 0 0 1 2-2h1.51a2 2 0 0 0 2-2v-.891a2 2 0 0 0-2-2h-1.51a2 2 0 0 1-2-2v-2.136c5.926-1.143 10.405-6.357 10.405-12.616C25.849 5.753 20.095 0 13 0Zm0 5.11a7.74 7.74 0 1 1 0 15.478A7.74 7.74 0 0 1 13 5.11Z",
    fill: "#FF8787"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "closeModal-button-mobile",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 10 10 30M10 10l20 20",
    stroke: "#212121",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "closeModal-button",
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.41 11 8.29-8.29a1 1 0 0 0-1.41-1.41L11 9.59l-8.29-8.3a1.004 1.004 0 1 0-1.42 1.42L9.59 11l-8.3 8.29A1 1 0 1 0 2.7 20.7l8.3-8.29 8.29 8.29a1 1 0 0 0 1.41-1.41L12.41 11Z",
    fill: "#000"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "logout-desc",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.204 11.146v-.001Zm.42.42Zm0-5.061Z",
    fill: "#F59256",
    stroke: "#F59256",
    strokeWidth: 2
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "edit-pen-desk",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.683 16.149a.833.833 0 0 1-.614-.272.824.824 0 0 1-.219-.636l.204-2.245 9.432-9.429 2.947 2.947-9.429 9.428-2.245.204a.8.8 0 0 1-.076.003ZM14.022 5.925l-2.947-2.947 1.768-1.767a.833.833 0 0 1 1.179 0l1.767 1.767a.834.834 0 0 1 0 1.18l-1.766 1.766h-.001Z",
    fill: "#F59256"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "edit-button-desk",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 7.708a2.708 2.708 0 1 0 0 5.417 2.708 2.708 0 0 0 0-5.417Z",
    fill: "#F59256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.708.208c-1.15 0-2.083.933-2.083 2.084v.148a.685.685 0 0 1-.685.685A3.899 3.899 0 0 0 .042 7.024v3.842c0 1.336 0 2.384.08 3.22.08.854.248 1.552.626 2.168a4.792 4.792 0 0 0 1.582 1.581c.615.378 1.314.546 2.167.627.837.08 1.884.08 3.22.08h2.566c1.336 0 2.383 0 3.22-.08.853-.081 1.552-.25 2.167-.627a4.792 4.792 0 0 0 1.582-1.581c.378-.616.546-1.315.627-2.168.08-.836.08-1.884.08-3.22V7.024a3.899 3.899 0 0 0-3.9-3.9.684.684 0 0 1-.684-.684v-.148c0-1.151-.933-2.084-2.083-2.084H6.708ZM5.042 10.417a3.958 3.958 0 1 1 7.916 0 3.958 3.958 0 0 1-7.916 0ZM14 7.917a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Z",
    fill: "#F59256"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "burger-menu-mobile",
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20h30v-3.333H0V20Zm0-8.333h30V8.333H0v3.334ZM0 0v3.333h30V0H0Z",
    fill: "#212121"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "burger-menu-tablet",
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20h30v-3.333H0V20Zm0-8.333h30V8.333H0v3.334ZM0 0v3.333h30V0H0Z",
    fill: "#212121"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "heart-home-page-desc",
    viewBox: "0 0 92 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.107.573c8.684-2.28 18.417 2.51 23.33 9.708 4.693 6.761 5.97 16.291 2.6 23.864-1.23 2.677-3.194 5.045-5.09 7.33-.292.353-.584.704-.87 1.055-2.53 3.258-4.916 6.864-6.389 10.625-1.578 3.98-2.127 8.302-2.665 12.539l-.21 1.64c-.275 1.8-.548 3.6-.797 5.403.02 2.15-.221 4.3-.78 6.37-.367 2.585-1.044 5.128-2.683 7.185-1.506 1.981-3.713 2.697-6.02 2.664-.684.081-1.399.053-2.141-.108a10.695 10.695 0 0 1-2.618-.877c-.238-.091-.47-.187-.7-.287-3.729-1.67-6.802-4.486-9.161-7.79-1.024-.897-2.055-1.786-3.086-2.676-.41-.367-.818-.737-1.227-1.109-3.165-2.868-6.393-5.795-10.18-7.791-3.565-1.899-7.723-3.086-11.763-3.916-.446-.08-.896-.157-1.349-.235-2.925-.503-5.956-1.024-8.632-2.257C6.19 58.35.962 50.28.131 42.09c-.95-8.663 3.327-18.631 11.406-22.548 8.318-4.034 18.536-1.542 26.378 2.137a68.475 68.475 0 0 1 5.418 2.758 68.411 68.411 0 0 1 2.127-5.087C49.024 11.456 55.165 2.917 64.107.573Z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 86.509,
    y1: 39.896,
    x2: -54.221,
    y2: 71.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "line-mobile",
    viewBox: "0 0 200 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 4,
    rx: 2,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    y1: 2.154,
    x2: 210.888,
    y2: 2.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF634E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF48"
  }))))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "line-tablet",
    viewBox: "0 0 280 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 8,
    rx: 4,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    y1: 4.308,
    x2: 295.244,
    y2: 4.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF634E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF48"
  }))))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "line-desc",
    viewBox: "0 0 340 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 0 1 4-4h332a4 4 0 0 1 0 8H4a4 4 0 0 1-4-4Z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    y1: 4.308,
    x2: 358.51,
    y2: 4.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF634E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF48"
  }))))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "delete-button",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 2.75h2.5a1.25 1.25 0 0 0-2.5 0Zm-1.25 0a2.5 2.5 0 1 1 5 0h5a.625.625 0 1 1 0 1.25h-.705l-1.506 11.047a3.125 3.125 0 0 1-3.096 2.703H6.808a3.125 3.125 0 0 1-3.097-2.703L2.205 4H1.5a.625.625 0 0 1 0-1.25h5Zm1.25 4.375a.625.625 0 0 0-1.25 0v6.25a.625.625 0 1 0 1.25 0v-6.25Zm3.125-.625a.625.625 0 0 0-.625.625v6.25a.624.624 0 1 0 1.25 0v-6.25a.625.625 0 0 0-.625-.625Z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "heart",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 1C3.687 1 1 3.734 1 7.106c0 2.723 1.05 9.185 11.386 15.717a1.158 1.158 0 0 0 1.228 0C23.95 16.29 25 9.829 25 7.106 25 3.734 22.313 1 19 1s-6 3.7-6 3.7S10.313 1 7 1Z",
    fill: "#fff",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 1C3.687 1 1 3.734 1 7.106c0 2.723 1.05 9.185 11.386 15.717a1.158 1.158 0 0 0 1.228 0C23.95 16.29 25 9.829 25 7.106 25 3.734 22.313 1 19 1s-6 3.7-6 3.7S10.313 1 7 1Z",
    stroke: "#F59256",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -4,
    y: -4,
    width: 34,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2702_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2702_59",
    result: "shape"
  }))))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "search-mobile",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.917 9.667h-.659l-.233-.225a5.393 5.393 0 0 0 1.308-3.525 5.416 5.416 0 1 0-5.416 5.416 5.393 5.393 0 0 0 3.525-1.308l.225.233v.659l4.166 4.158 1.242-1.242-4.158-4.166Zm-5 0a3.745 3.745 0 0 1-3.75-3.75 3.745 3.745 0 0 1 3.75-3.75 3.745 3.745 0 0 1 3.75 3.75 3.745 3.745 0 0 1-3.75 3.75Z",
    fill: "#111"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11h-.79l-.28-.27A6.471 6.471 0 0 0 13 6.5 6.5 6.5 0 1 0 6.5 13c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L17.49 16l-4.99-5Zm-6 0C4.01 11 2 8.99 2 6.5S4.01 2 6.5 2 11 4.01 11 6.5 8.99 11 6.5 11Z",
    fill: "#111"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus-add-pet-mobile",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.666V12v10.666ZM12 12V1.333 12Zm0 0h10.666H12Zm0 0H1.333 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.666V12m0 0V1.333M12 12h10.666M12 12H1.333",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus-add-pet",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17V9m0 0V1m0 8h8M9 9H1",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "avatar-account",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2.333C7.56 2.333 2.333 7.56 2.333 14c0 6.44 5.227 11.667 11.667 11.667 6.44 0 11.666-5.227 11.666-11.667C25.666 7.56 20.44 2.333 14 2.333ZM14 7a4.088 4.088 0 0 1 4.083 4.083A4.088 4.088 0 0 1 14 15.167a4.088 4.088 0 0 1-4.084-4.084A4.088 4.088 0 0 1 14 7Zm0 16.333c-2.369 0-5.169-.956-7.164-3.36a11.604 11.604 0 0 1 14.327 0c-1.995 2.404-4.795 3.36-7.163 3.36Z",
    fill: "#fff"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "chat",
    fill: "white",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.708 7.024c-1.209 0-2.377 0.19-3.471 0.564-1.025 0.351-1.936 0.846-2.709 1.472-1.433 1.16-2.223 2.645-2.223 4.182 0 0.859 0.24 1.694 0.714 2.48 0.494 0.82 1.239 1.571 2.155 2.171 0.727 0.477 1.216 1.24 1.345 2.099 0.022 0.143 0.039 0.287 0.052 0.43 0.065-0.060 0.129-0.122 0.194-0.186 0.576-0.574 1.353-0.891 2.156-0.891 0.128 0 0.256 0.008 0.384 0.024 0.462 0.059 0.934 0.088 1.402 0.088 1.209 0 2.377-0.19 3.471-0.564 1.025-0.351 1.936-0.846 2.709-1.471 1.433-1.16 2.223-2.645 2.223-4.182s-0.789-3.022-2.223-4.182c-0.773-0.626-1.685-1.121-2.709-1.472-1.093-0.374-2.261-0.564-3.471-0.564zM13.708 3.969v0c6.328 0 11.458 4.152 11.458 9.273s-5.13 9.273-11.458 9.273c-0.608 0-1.204-0.039-1.786-0.112-2.461 2.451-5.304 2.891-8.144 2.956v-0.6c1.534-0.748 2.769-2.112 2.769-3.67 0-0.217-0.017-0.431-0.048-0.64-2.591-1.7-4.248-4.297-4.248-7.207 0-5.121 5.13-9.273 11.458-9.273zM26.026 24.753c0 1.335 0.867 2.504 2.196 3.146v0.514c-2.462-0.055-4.721-0.432-6.855-2.533-0.505 0.063-1.021 0.096-1.548 0.096-2.279 0-4.378-0.615-6.054-1.648 3.454-0.012 6.714-1.119 9.187-3.119 1.246-1.009 2.229-2.192 2.922-3.517 0.734-1.405 1.107-2.902 1.107-4.45 0-0.249-0.011-0.497-0.030-0.744 1.732 1.431 2.799 3.381 2.799 5.53 0 2.494-1.436 4.72-3.682 6.177-0.027 0.179-0.042 0.362-0.042 0.548z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "heart-button",
    width: 16,
    height: 16,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.167 1c-1.84 0-3.333 1.477-3.333 3.3 0 1.471.583 4.963 6.325 8.493a.657.657 0 0 0 .682 0c5.743-3.53 6.326-7.022 6.326-8.493 0-1.823-1.493-3.3-3.333-3.3C9.993 1 8.5 3 8.5 3S7.008 1 5.167 1Z",
    fill: "#F59256",
    stroke: "#F59256",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "close-small-modal-mobile",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.097 8 6.447-6.448A.778.778 0 0 0 14.448.455L8 6.903 1.552.447A.78.78 0 1 0 .448 1.552L6.903 8 .448 14.447a.777.777 0 1 0 1.096 1.097L8 9.096l6.448 6.448a.778.778 0 0 0 1.096-1.097L9.097 8Z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit_check",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--color1, #f59256)"
    },
    d: "M26.976 5.252c0.923 0.879 0.959 2.34 0.080 3.263l-14.646 15.385c-0.436 0.458-1.040 0.716-1.671 0.716s-1.236-0.259-1.671-0.716l-6.892-7.24c-0.879-0.923-0.843-2.384 0.080-3.263s2.384-0.843 3.263 0.080l5.221 5.484 12.975-13.629c0.879-0.923 2.339-0.959 3.263-0.080z"
  })), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit_pencil",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.976 26.214c-0.165-0-0.328-0.035-0.48-0.102s-0.287-0.164-0.398-0.286c-0.113-0.121-0.2-0.264-0.254-0.421s-0.074-0.323-0.059-0.488l0.292-3.207 13.474-13.469 4.211 4.21-13.47 13.468-3.207 0.292c-0.036 0.003-0.072 0.005-0.108 0.005zM24.603 11.608l-4.21-4.21 2.525-2.525c0.111-0.111 0.242-0.199 0.386-0.258s0.299-0.091 0.456-0.091c0.156 0 0.311 0.031 0.456 0.091s0.276 0.148 0.387 0.258l2.525 2.525c0.111 0.111 0.199 0.242 0.259 0.386s0.091 0.299 0.091 0.456c0 0.156-0.031 0.311-0.091 0.456s-0.148 0.276-0.259 0.386l-2.525 2.525z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.7778,
    d: "M27.209 11.682l0-0c0.141-0.141 0.369-0.141 0.511 0l2.799 2.799c0.871 0.871 0.871 2.291 0 3.162l-2.799 2.799c-0.071 0.071-0.162 0.106-0.255 0.106s-0.184-0.035-0.255-0.106h-0c-0.141-0.141-0.141-0.369 0-0.51l3.508-3.509h-17.155c-0.2 0-0.361-0.162-0.361-0.361s0.162-0.361 0.361-0.361h17.155l-3.508-3.509c-0.141-0.141-0.141-0.369 0-0.51zM21.736 24.5v2.5c0 2.266-1.845 4.111-4.111 4.111h-12.563c-2.266 0-4.111-1.845-4.111-4.111v-22c0-2.266 1.845-4.111 4.111-4.111h12.563c2.266 0 4.111 1.845 4.111 4.111v2.5c0 0.2-0.162 0.361-0.361 0.361s-0.361-0.162-0.361-0.361v-2.5c0-1.869-1.519-3.389-3.389-3.389h-12.563c-1.869 0-3.389 1.52-3.389 3.389v22c0 1.869 1.52 3.389 3.389 3.389h12.563c1.869 0 3.389-1.52 3.389-3.389v-2.5c0-0.199 0.162-0.361 0.361-0.361s0.361 0.162 0.361 0.361z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-avatar-check",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.293 5.293l-10.293 10.293-4.293-4.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l5 5c0.391 0.391 1.024 0.391 1.414 0l11-11c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-avatar-close",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.293 6.707l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5.293-5.293 5.293 5.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-5.293-5.293 5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-google-logo",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    style: {
      fill: "var(--color1, #4285f4)"
    },
    d: "M30.080 16.333c0-1.040-0.093-2.040-0.267-3h-13.813v5.68h7.893c-0.347 1.827-1.387 3.373-2.947 4.413v3.693h4.76c2.773-2.56 4.373-6.32 4.373-10.787z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    style: {
      fill: "var(--color2, #34a853)"
    },
    d: "M16 30.667c3.96 0 7.28-1.307 9.707-3.547l-4.76-3.693c-1.307 0.88-2.973 1.413-4.947 1.413-3.813 0-7.053-2.573-8.213-6.040h-4.88v3.787c2.413 4.787 7.36 8.080 13.093 8.080z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    style: {
      fill: "var(--color3, #fbbc05)"
    },
    d: "M7.787 18.787c-0.293-0.88-0.467-1.813-0.467-2.787s0.173-1.907 0.467-2.787v-3.787h-4.88c-1 1.973-1.573 4.2-1.573 6.573s0.573 4.6 1.573 6.573l3.8-2.96 1.080-0.827z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    style: {
      fill: "var(--color4, #ea4335)"
    },
    d: "M16 7.173c2.16 0 4.080 0.747 5.613 2.187l4.2-4.2c-2.547-2.373-5.853-3.827-9.813-3.827-5.733 0-10.68 3.293-13.093 8.093l4.88 3.787c1.16-3.467 4.4-6.040 8.213-6.040z"
  })), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ci_edit",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.055 5.462c0.96 0.914 0.997 2.433 0.083 3.393l-15.232 16c-0.453 0.476-1.081 0.745-1.738 0.745s-1.285-0.269-1.738-0.745l-7.168-7.529c-0.914-0.96-0.877-2.479 0.083-3.393s2.479-0.877 3.393 0.083l5.43 5.703 13.494-14.174c0.914-0.96 2.433-0.997 3.393-0.083z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "heart-unlike",
    width: 24,
    height: 22,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.167 1c-1.84 0-3.333 1.477-3.333 3.3 0 1.471.583 4.963 6.325 8.493a.657.657 0 0 0 .682 0c5.743-3.53 6.326-7.022 6.326-8.493 0-1.823-1.493-3.3-3.333-3.3C9.993 1 8.5 3 8.5 3S7.008 1 5.167 1Z",
    fill: "#F59256",
    stroke: "#F59256",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 2.75H10.25C10.25 2.41848 10.1183 2.10054 9.88388 1.86612C9.64946 1.6317 9.33152 1.5 9 1.5C8.66848 1.5 8.35054 1.6317 8.11612 1.86612C7.8817 2.10054 7.75 2.41848 7.75 2.75ZM6.5 2.75C6.5 2.08696 6.76339 1.45107 7.23223 0.982233C7.70107 0.513392 8.33696 0.25 9 0.25C9.66304 0.25 10.2989 0.513392 10.7678 0.982233C11.2366 1.45107 11.5 2.08696 11.5 2.75H16.5C16.6658 2.75 16.8247 2.81585 16.9419 2.93306C17.0592 3.05027 17.125 3.20924 17.125 3.375C17.125 3.54076 17.0592 3.69973 16.9419 3.81694C16.8247 3.93415 16.6658 4 16.5 4H15.795L14.2887 15.0475C14.1866 15.7962 13.8166 16.4825 13.2474 16.9793C12.6781 17.4762 11.9481 17.75 11.1925 17.75H6.8075C6.0519 17.75 5.32189 17.4762 4.75263 16.9793C4.18336 16.4825 3.81341 15.7962 3.71125 15.0475L2.205 4H1.5C1.33424 4 1.17527 3.93415 1.05806 3.81694C0.940848 3.69973 0.875 3.54076 0.875 3.375C0.875 3.20924 0.940848 3.05027 1.05806 2.93306C1.17527 2.81585 1.33424 2.75 1.5 2.75H6.5ZM7.75 7.125C7.75 6.95924 7.68415 6.80027 7.56694 6.68306C7.44973 6.56585 7.29076 6.5 7.125 6.5C6.95924 6.5 6.80027 6.56585 6.68306 6.68306C6.56585 6.80027 6.5 6.95924 6.5 7.125V13.375C6.5 13.5408 6.56585 13.6997 6.68306 13.8169C6.80027 13.9342 6.95924 14 7.125 14C7.29076 14 7.44973 13.9342 7.56694 13.8169C7.68415 13.6997 7.75 13.5408 7.75 13.375V7.125ZM10.875 6.5C10.7092 6.5 10.5503 6.56585 10.4331 6.68306C10.3158 6.80027 10.25 6.95924 10.25 7.125V13.375C10.25 13.5408 10.3158 13.6997 10.4331 13.8169C10.5503 13.9342 10.7092 14 10.875 14C11.0408 14 11.1997 13.9342 11.3169 13.8169C11.4342 13.6997 11.5 13.5408 11.5 13.375V7.125C11.5 6.95924 11.4342 6.80027 11.3169 6.68306C11.1997 6.56585 11.0408 6.5 10.875 6.5Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "plusImg",
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 50.1787V25.8887M25 25.8887V1.59863M25 25.8887H49M25 25.8887H1",
    stroke: "#111111",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.5b79aea691ad35980bf68376d65a1d83.svg";
export { ForwardRef as ReactComponent };